<div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="calc-wrapper">
  <div mat-dialog-title class="m-0 mat-dialog-title">
    <span class="esc">Press Esc To Close</span>
    <h1></h1>
  </div>
  <div mat-dialog-content class="mat-dialog-content eip-messagebox-content">
    <eip-calculator></eip-calculator>
    <span>Press Esc To Close</span>
  </div>
</div>